// Module
var code = `<th class="selectable" data-ng-click="onClick()"> <span ng-transclude class="pull-left sortable-span"></span> <span class="pull-right" ng-if="!!order"> <sort-icon reverse="{{ pageable.order === order ? pageable.reverse : undefined }}"></sort-icon> </span> </th> `;
// Exports
module.exports = code;